import { Languages } from "lucide-react";
import { useI18n } from "@/i18n";

export default function LangSelect({ dark = false }) {
  const { lang, setLang, langs } = useI18n();
  return (
    <span className="inline-flex items-center gap-1.5" data-testid="lang-select-wrap">
      <Languages size={15} className={dark ? "text-night-soft" : "text-muted"} aria-hidden="true" />
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        data-testid="lang-select"
        aria-label="Select language"
        title="Select language"
        className={`max-w-[124px] cursor-pointer rounded-full border px-3 py-1.5 text-sm outline-none transition-colors focus:border-accent sm:max-w-[190px] ${
          dark
            ? "border-white/25 bg-transparent text-night-ink hover:border-accent-bright"
            : "border-line bg-surface text-ink hover:border-accent"
        }`}
      >
        {langs.map(([code, label]) => (
          <option key={code} value={code}>
            {label}
          </option>
        ))}
      </select>
    </span>
  );
}
